import React from "react";
import { Link } from "react-router-dom";
import "./landing.scss";

class Landing extends React.Component {
  render() {
    return (
      <div className="landing-page">
        <div className="landing-content">
          <h1 className="landing-title">dru</h1>
          <div className="landing-nav">
            <Link to="/software" className="landing-link">
              software
            </Link>
            <span className="landing-separator">/</span>
            <Link to="/music" className="landing-link">
              music
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Landing;



